import React from 'react';

import ReactDOM from 'react-dom';

export default class HotelName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      pristine: true
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  componentWillReceiveProps = nextProps => {
    if (typeof nextProps.hotel_name != 'undefined' && this.state.pristine) {
      this.setState({ value: nextProps.hotel_name, pristine: false });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => (
    <div
      className={`hotel-name select-wrapper animated-text-form extended ${
        this.state.active ? 'active' : ''
      } ${this.props.filter_active ? '' : 'filter-disabled'}`}
      ref={() => {
        this.returnSearchedValue = this.returnSearchedValue.bind(this);
      }}
    >
      <label className="animated-text-label" htmlFor="hotel-name-input">
        <span className="animated-text-label-name">{this.props.title}</span>
      </label>
      <input
        id="hotel-name-input"
        type="text"
        value={this.state.value}
        className="animated-text-input"
        onFocus={this.handleFocus}
        onChange={this.handleChange}
      />
    </div>
  );

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false });
    }
  };

  handleChange = event => this.setState({ value: event.target.value });

  handleFocus = () => {
    this.setState({ active: true });
  };

  returnSearchedValue = () =>
    this.state.value !== '' ? this.state.value : false;
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/hotel_name.js